import { Heading, InfoLabel, isEmpty, Text, VFlow } from 'bold-ui'
import {
  CondutaEnum,
  FornecimentoOdontoEnum,
  Procedimento,
  RacionalidadeEmSaudeEnum,
  SinanNotificacaoEvolucao,
  TipoEncaminhamentoOdontoEnum,
} from 'graphql/types.generated'
import { compact } from 'lodash'
import { condutaOdontoRecord } from 'types/enums'
import { emptyArrayOf } from 'util/array'
import { stringGrouper } from 'util/string/string-grouper'
import {
  fornecimentoOdontoDesfecho,
  historicoSubsectionStyles,
  racionalidadeEmSaudeDesfecho,
} from 'view/atendimentos/detail/historico/model/model-historico'
import { showCodigoProcedimento } from 'view/atendimentos/detail/soap/objetivo/resultados-exames/util-resultadosExames'
import { condutaDesfecho } from 'view/atendimentos/types/AtendimentoProfissionalModel'

import { naoRegistradoNesseAtendimento } from '../../../utils/utils-historico'
import HistoricoDetailTable from '../../table/HistoricoDetailTable'

interface HistoricoDesfechoPecPanelProps {
  condutas?: ReadonlyArray<CondutaEnum>
  condutasOdonto?: ReadonlyArray<TipoEncaminhamentoOdontoEnum>
  fornecimentos?: ReadonlyArray<FornecimentoOdontoEnum>
  notificacoesCasoSuspeito?: ReadonlyArray<SinanNotificacaoEvolucao>
  procedimentosAdministrativos?: Partial<Procedimento>[]
  racionalidadeEmSaude?: RacionalidadeEmSaudeEnum
}

export default function HistoricoDesfechoPecPanel(props: HistoricoDesfechoPecPanelProps) {
  const {
    condutas = emptyArrayOf<CondutaEnum>(),
    condutasOdonto = emptyArrayOf<TipoEncaminhamentoOdontoEnum>(),
    notificacoesCasoSuspeito,
    procedimentosAdministrativos,
    racionalidadeEmSaude,
    fornecimentos,
  } = props

  const compactedCondutas = compact(condutas)
  const compactedCondutasOdonto = compact(condutasOdonto)

  const hasDesfecho =
    !isEmpty(compactedCondutas) ||
    !isEmpty(compactedCondutasOdonto) ||
    !isEmpty(procedimentosAdministrativos) ||
    !isEmpty(notificacoesCasoSuspeito) ||
    !isEmpty(fornecimentos) ||
    racionalidadeEmSaude

  return hasDesfecho ? (
    <VFlow>
      {fornecimentos && (
        <InfoLabel title='Fornecimento'>
          {stringGrouper(...fornecimentos.map((fornecimento) => fornecimentoOdontoDesfecho[fornecimento]))}
        </InfoLabel>
      )}
      {procedimentosAdministrativos && (
        <VFlow vSpacing={0.5}>
          <Heading level={5} style={historicoSubsectionStyles.desfecho}>
            Procedimentos administrativos (SIGTAP)
          </Heading>
          <HistoricoDetailTable hasLines>
            <VFlow vSpacing={0.5}>
              {procedimentosAdministrativos
                .sort((a, b) => a.descricao.localeCompare(b.descricao))
                .map((proced) => (
                  <Text key={proced.id}>
                    {proced.descricao} - {showCodigoProcedimento(proced.codigo)}
                  </Text>
                ))}
            </VFlow>
          </HistoricoDetailTable>
        </VFlow>
      )}
      {notificacoesCasoSuspeito && (
        <VFlow vSpacing={0.5}>
          <Text fontWeight='bold'>Ficha de notificação de caso suspeito</Text>
          <HistoricoDetailTable hasLines>
            <VFlow vSpacing={0.5}>
              {notificacoesCasoSuspeito
                .toSorted((a, b) => a.notificacao.nomeNotificacao.localeCompare(b.notificacao.nomeNotificacao))
                .map((notificacao) => (
                  <Text key={notificacao.id}>{notificacao.notificacao.nomeNotificacao}</Text>
                ))}
            </VFlow>
          </HistoricoDetailTable>
        </VFlow>
      )}
      {racionalidadeEmSaude && (
        <InfoLabel title='Racionalidade em saúde'>{racionalidadeEmSaudeDesfecho[racionalidadeEmSaude]}</InfoLabel>
      )}
      {compactedCondutasOdonto.isEmpty() && compactedCondutas.isNotEmpty() && (
        <InfoLabel title='Conduta'>{stringGrouper(...condutas.map((conduta) => condutaDesfecho[conduta]))}</InfoLabel>
      )}
      {compactedCondutas.isEmpty() && compactedCondutasOdonto.isNotEmpty() && (
        <InfoLabel title='Conduta'>
          {stringGrouper(...condutasOdonto.map((conduta) => condutaOdontoRecord[conduta]))}
        </InfoLabel>
      )}
    </VFlow>
  ) : (
    <Text fontStyle='italic'>{naoRegistradoNesseAtendimento}</Text>
  )
}
